import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SecureEftApi} from 'src/app/api/eft-secure/eft-secure.api.class';

@Injectable({
  providedIn: 'root'
})
export class SecureEftService {

  constructor(private secureEftApi: SecureEftApi) {}

  initializePayment(sessionToken: string): Observable<any> {
    return this.secureEftApi.initializePayment(sessionToken);
  }

  getTransactionStatus(sessionToken: string): Observable<object> {
    return this.secureEftApi.getTransactionStatus(sessionToken);
  }

}
